import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from './sidebar.js'
import Navbar from './navbar.js'


const Layout = ({
  children,
}) => (
  <div className="main-layout">
    <Sidebar />
    <Navbar />
    <div className="layout-container">
      <div className="container-fluid">
        {children}
      </div>
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout;


// WEBPACK FOOTER //
// ./src/app/components/complex/layout.js